import { render, staticRenderFns } from "./ArchivePostDocs.vue?vue&type=template&id=78e71bf4&scoped=true&"
import script from "./ArchivePostDocs.vue?vue&type=script&lang=js&"
export * from "./ArchivePostDocs.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePostDocs.vue?vue&type=style&index=0&id=78e71bf4&prod&lang=css&"
import style1 from "./ArchivePostDocs.vue?vue&type=style&index=1&id=78e71bf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e71bf4",
  null
  
)

export default component.exports